
import { computed, defineComponent, onBeforeUnmount, Ref, ref } from "vue";
import { ElConfigProvider } from "element-plus";
import useEmitter from "@/composables/Emmiter";
import Button from "@/components/Button.vue"


export default defineComponent({
  name: "ModalAdicionarLubrificante",
  components: {
    Button, 
    ElConfigProvider
  },
  props: {
    fechaModal: Function,
    marcas: { type: Array as () => Array<{ nome: string; id_marca_produto: string | number }>, default: () => [] },
  },
  setup(props, { emit }) {
    //ALERTS TOASTS
    const spanWarning = ref(false);

    //VARIAVEIS DE CONTROLE
    const loadSalvar: Ref<boolean> = ref(false);
    const emitter = useEmitter();
    const imagem = ref<HTMLInputElement>();
    const marcasDeLubrificantes = computed(() => props.marcas);
    const lubForm: Ref<any> = ref({
      marca: "",
      produto: "",
      viscosidade: "",
      tipo: "",
      combustivel: "",
      descricao: "",
      acea: "",
      api: "",
      ilsac: "",
      norma_bmw: "",
      norma_chrysler: "",
      norma_fiat: "",
      norma_ford: "",
      norma_gm: "",
      norma_jaguar_land_rover: "",
      norma_mercedes: "",
      norma_psa: "",
      norma_renault: "",
      norma_vw: "",
      imagem: "",
      correspondencia: ""
    });
    
    function verifySelectValues(e) {
      e.preventDefault();
      if (!lubForm.value.tipo || !lubForm.value.marca || !lubForm.value.viscosidade || !lubForm.value.produto) {
        spanWarning.value = true;
        return true;
      }
      spanWarning.value = false;
      addLub();
    }

    async function addLub() {
      await emitter.emit("addLub", {
        lubForm: lubForm.value,
      });
      // resetar outros campos do form (se necessário)
        lubForm.value = {
          marca: "",
          produto: "",
          viscosidade: "",
          tipo: "",
          combustivel: "",
          descricao: "",
          acea: "",
          api: "",
          ilsac: "",
          norma_bmw: "",
          norma_chrysler: "",
          norma_fiat: "",
          norma_ford: "",
          norma_gm: "",
          norma_jaguar_land_rover: "",
          norma_mercedes: "",
          norma_psa: "",
          norma_renault: "",
          norma_vw: "",
          imagem: "",
          correspondencia: ""
        };
    }

    // helper para gerar preview
    let currentObjectUrl: string | null = null;
    function buildImagePreview(img: any) {
      if (!img) return null;
      if (img instanceof File) {
        if (currentObjectUrl) URL.revokeObjectURL(currentObjectUrl);
        currentObjectUrl = URL.createObjectURL(img);
        return currentObjectUrl;
      }
      // string (URL)
      return typeof img === "string" ? img : null;
    }

    const fileName = computed(() => {
        const v = lubForm.value.imagem;
        return v instanceof File ? v.name : "";
    });

    function handleImgFileChange(event: Event) {
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];
      if (file) {
        lubForm.value.imagem = file;
        lubForm.value.imagemPreview = buildImagePreview(file);
      }
    }

    // handlers para atualizar o spinner e fechar o modal quando finalizado
    const startHandler = () => {
      loadSalvar.value = true;
    };

    const finishHandler = (payload?: any) => {
      loadSalvar.value = false;
      // fecha o modal somente depois de terminar
      // opcional: você pode checar payload.success para mostrar mensagem
      if(payload?.success){
        props.fechaModal && props.fechaModal();
      }
    };

    if (emitter && emitter.on) {
      emitter.on("addLub:start", startHandler);
      emitter.on("addLub:finish", finishHandler);
    }

    // remove listeners quando componente desmontar
    onBeforeUnmount(() => {
      if (emitter && emitter.off) {
        emitter.off("addLub:start", startHandler);
        emitter.off("addLub:finish", finishHandler);
      }
    });

    function openFileDialog() {
      imagem.value?.click();
    }
    

    return {
      spanWarning,
      lubForm,
      verifySelectValues,
      marcasDeLubrificantes,
      loadSalvar,
      handleImgFileChange,
      fileName,
      openFileDialog,
      imagem
    };
  }
});
